import type { StackComponentProps } from "../types";

/**
 * StackComponent - renders a vertical or horizontal stack of components.
 */
function StackComponent({ items = [], gap = "gap-4", direction = "vertical", justify, renderChild }: StackComponentProps) {
  const flexDirection = direction === "horizontal" ? "flex-row" : "flex-col";
  const alignItems = direction === "horizontal" ? "items-stretch" : "";
  const width = direction === "horizontal" ? "w-full" : "";
  const justifyContent = justify ? `justify-${justify}` : "";
  
  return (
    <div className={`flex ${flexDirection} ${alignItems} ${justifyContent} ${width} ${gap}`}>
      {items.map((item, index) => {
        const rendered = renderChild(item);
        // For horizontal layout, use flex-1 for equal width distribution, or inline-flex for natural sizing
        if (direction === "horizontal") {
          // Check if this is a card/container that should take equal space and match height
          const isCardContainer = item?.component === "stack" || item?.component === "informationCard";
          // If justify is set, don't force flex-1 on items (let justify handle spacing)
          const shouldFlex = isCardContainer && !justify;
          return (
            <div key={index} className={shouldFlex ? "flex-1 min-w-0 flex flex-col h-full" : "inline-flex items-center"}>
              {rendered}
            </div>
          );
        }
        return <div key={index}>{rendered}</div>;
      })}
    </div>
  );
}

export { StackComponent };
